// extracted by mini-css-extract-plugin
export default {"header":"Header_header__EuQXz","main-image":"Header_main-image__Cw+p6"};